import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "eva-tree"
};
var _hoisted_2 = {
  class: "eva-tree__content"
};
import { ref } from 'vue';
import TreeItem from './TreeItem.vue';
export default {
  __name: 'TargetTree',
  props: {
    treeData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    level: {
      type: Number,
      default: 0
    }
  },
  emits: ['checkTarget'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var treeValue = ref('');

    /**
     * @description 选择目标
     * @param {Object} item
     */
    var onChangeEvent = function onChangeEvent(item) {
      treeValue.value = item.targetId.toString();
      emit('checkTarget', item);
    };
    return function (_ctx, _cache) {
      var _component_empty = _resolveComponent("empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.treeData, function (item) {
        return _openBlock(), _createBlock(TreeItem, {
          key: item.id,
          level: __props.level,
          item: item,
          value: treeValue.value,
          onOnChange: onChangeEvent
        }, null, 8, ["level", "item", "value"]);
      }), 128)), __props.treeData.length === 0 ? (_openBlock(), _createBlock(_component_empty, {
        key: 0
      })) : _createCommentVNode("", true)])]);
    };
  }
};